
import { JsonObject, JsonProperty } from 'json2typescript';


@JsonObject('City')
export class City {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('roll_rank', Number, true)
    rank: number = undefined;

    @JsonProperty('name', String, true)
    name = null;

    @JsonProperty('name_ar', String, true)
    nameAr = null;

    get getName() {
        return this.name || this.nameAr;
    }
}